const SignLayout = ({ children }) => {
  return (
    <div className="d-flex w-100 h-100">
      <div className="row w-100" id="sigin">
        <div style={{ backgroundImage: "url('/sign-bg.jpg')" }} className="d-none d-md-flex col-6 h-100 main-bg"></div>
        <div className="col-md-6">{children}</div>
      </div>
    </div>
  );
};

export default SignLayout;
